import COUNTRIES from '../countries.translations'

import translations from './manganese.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/manganese'

export const manganese: Metal = {
  id: 14,
  slug: 'manganese',
  name: t.name,
  symbol: 'Mn',
  mines: [
    {
      name: "Kalahari Manganese Field: Hotazel & Black Rock (South Africa, Assmang/South32 — world's largest manganese deposit)",
      region: t.mine0Region,
      slug: 'kalahari-manganese-field',
      coordinates: [22.96, -27.19],
    },
    {
      name: 'GEMCO, Groote Eylandt (Australia, South32)',
      region: t.mine1Region,
      slug: 'gemco-groote-eylandt',
      coordinates: [136.47, -13.97],
    },
    {
      name: 'Moanda/Comilog (Gabon, Eramet)',
      region: t.mine2Region,
      slug: 'moanda-comilog',
      coordinates: [13.27, -1.57],
    },
  ],
  countries: [
    { name: COUNTRIES.southAfrica, percent: 37 },
    { name: COUNTRIES.gabon, percent: 23 },
    { name: COUNTRIES.australia, percent: 15 },
  ],
  content: {
    smartphone: {
      quantityScore: 3,
      quantityLabel: t.smartphone.label,
      parts: ['battery'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 3, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
